export default __webpack_public_path__ + "static/media/MTC_GT_Small.42f6092c.png";